<template>
  <v-menu min-width="300" bottom left>
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on">
        <v-icon small>
          mdi-dots-vertical
        </v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item @click="$emit('openUnlinkServiceProviderModal', item, true)">
        <v-list-item-title>
          <div class="d-flex gap-1">
            <v-icon color="grey lighten-1" small>
              mdi-account-file-text-outline
            </v-icon>
            <span class="body-2">
              {{ $t('customer.label.unlinkServiceProvider') }}
            </span>
          </div>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'ServiceProviderCustomerListMenu',

  props: {
    item: {
      type: Object,
      required: true,
    },
  },
}
</script>
